var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4288 15.4288L20 20M10.5454 4C9.25086 4 7.98537 4.38388 6.90898 5.1031C5.83259 5.82232 4.99365 6.84458 4.49824 8.04059C4.00284 9.23661 3.87321 10.5527 4.12577 11.8224C4.37833 13.0921 5.00172 14.2583 5.91711 15.1737C6.8325 16.0891 7.99879 16.7125 9.26847 16.9651C10.5382 17.2176 11.8542 17.088 13.0502 16.5926C14.2463 16.0972 15.2685 15.2582 15.9877 14.1819C16.707 13.1055 17.0908 11.84 17.0908 10.5454C17.0907 8.8095 16.4011 7.14471 15.1736 5.91723C13.9461 4.68975 12.2813 4.00011 10.5454 4Z",
    stroke: "#505762",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.85f2112f3d72aa590259645554510af0.svg";
export { ForwardRef as ReactComponent };